import { render } from "./EmergencyDetail.vue?vue&type=template&id=fad8603c&scoped=true&ts=true"
import script from "./EmergencyDetail.ts?vue&type=script&lang=ts"
export * from "./EmergencyDetail.ts?vue&type=script&lang=ts"

import "./EmergencyDetail.scss?vue&type=style&index=0&id=fad8603c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fad8603c"]])

export default __exports__